// RequirementModel.js
import React, {useState, useEffect} from "react";
import axios from "axios";
import {baseUrl} from "../comman/config";
import toast from "react-hot-toast";

const RequirementModel = ({ showModal, setShowModal, item, ingredientsList,lockScreen, clearItem  }) => {
  const [itemIngredientList , setItemIngredientList] = useState([]);
  useEffect(() => {
    if (showModal) {
      setItemIngredientList(ingredientsList);
    }
  }, [showModal, ingredientsList]);

  const handleInputChange = (index) => (e) => {
    const { name, value } = e.target;
    
    setItemIngredientList((prevFormData) => {
      const updatedFormData = [...prevFormData];
      if(name === "wastage"){
        const gross_qty = (parseFloat(updatedFormData[index].required_qty) + (parseFloat(updatedFormData[index].required_qty) * (value / 100))).toFixed(3);
        updatedFormData[index] = { ...updatedFormData[index], [name]: value, gross_required_qty : gross_qty };
      }else{
        updatedFormData[index] = { ...updatedFormData[index], [name]: value };
      }
      return updatedFormData;
    });
  };

  const handleAddItem = async() => {
    try{
      const response = await axios.post(`${baseUrl}/requirement/ingredient_update`,
        { ingredientsList : itemIngredientList,
          item: item});
          toast.success("Item added successfully!");
          handleClose();
    }catch (error) {
      toast.error("Failed to add item. Please try again.");
    }
    
  }

  const handleSumitForOrder = async() => {
    try{
      if(window.confirm(`આ શાકભાજી "ઓર્ડર" માટે મોકલી રહ્યા છીએ. હવે પછી આ આઈટમ માટેની શાકભાજી ની જરૂરીયાત" માં કોઈ સુધારો થઇ શકશે નહી .
કોઈ કારણસર કોઈ સુધારો કરવાનો થાય તો શાકભાજી "ઓર્ડેર" કરતી સમયે  ફેરફાર કરી લેવા.
શું તમે "ઓર્ડર" માટે આગળ મોકલવા  માંગો છો ?`)){
        const response = await axios.post(`${baseUrl}/requirement/submit_for_order`,
          { ingredientsList : itemIngredientList,
            item: item});
            toast.success("Submit for order successfully!");
            handleClose();
      }
      
    }catch (error) {
      toast.error("Failed to submit for order. Please try again.");
    }
  }
    

  const handleClose = () => {
    setShowModal(false);
    clearItem(); // Clear the selected item when closing the modal
  };
  if (!showModal) return null;
  
  return (
    <>
      {showModal ? (
        <>
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
            <div className="relative w-full max-w-5xl mx-auto my-6 px-2 sm:px-4 lg:px-8">
              {/*content*/}
              <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none max-h-[90vh]">
                {/*header*/}
                <div className="flex items-start justify-between p-3 sm:p-5 border-b border-solid border-blueGray-200 rounded-t">
                  <div className="flex flex-col sm:flex-row sm:space-x-4 space-y-1 sm:space-y-0">
                    <span className="text-sm sm:text-base"><strong>Item:</strong> {item?.eng_name}</span>
                    <span className="text-sm sm:text-base"><strong>Kit:</strong> {item?.kit_no}</span>
                  </div>
                  <button
                    className="p-1 ml-auto bg-transparent border-0 text-black opacity-70 hover:opacity-100 float-right text-2xl leading-none font-semibold outline-none focus:outline-none"
                    onClick={handleClose}
                  >
                    <span className="bg-transparent text-black h-6 w-6 text-2xl block outline-none focus:outline-none">
                      ×
                    </span>
                  </button>
                </div>
                <div className="relative p-3 sm:p-6 flex-auto max-h-[60vh] md:max-h-[70vh] overflow-y-auto">
                  {/* Desktop Table View */}
                  <div className="hidden md:block">
                    <table className="border w-full text-xs sm:text-sm md:text-base">
                      <thead>
                        <tr>
                          <th className="p-2 border border-gray-300 bg-gray-50">Ingredient</th>
                          <th className="p-2 border border-gray-300 bg-gray-50">Required Qty</th>
                          <th className="p-2 border border-gray-300 bg-gray-50">Avg. Wastage (%)</th>
                          <th className="p-2 border border-gray-300 bg-gray-50">Gross Required Qty</th>
                        </tr>
                      </thead>
                      <tbody>
                        {itemIngredientList.map((item, index) => (
                          <tr key={index}>
                            <td className="p-2 text-center border border-gray-300">{item?.ingredient}</td>
                            <td className="p-2 text-center border border-gray-300">{item?.required_qty}</td>
                            <td className="p-2 text-center border border-gray-300">
                              <input type="number"
                                id="wastage"
                                name="wastage"
                                value={item?.wastage}
                                onChange={handleInputChange(index)}
                                onWheel={(e) => e.target.blur()}
                                onKeyDown={(e) => {
                                  if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                    e.preventDefault();
                                  }
                                }}
                                className="px-2 py-1 border rounded-md w-20 bg-orange-50"
                                disabled={lockScreen}
                              />
                            </td>
                            <td className="p-2 text-center border border-gray-300">
                              <input type="number"
                                id="gross_required_qty"
                                name="gross_required_qty"
                                value={item?.gross_required_qty}
                                onChange={handleInputChange(index)}
                                disabled={lockScreen}
                                onWheel={(e) => e.target.blur()}
                                onKeyDown={(e) => {
                                  if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                    e.preventDefault();
                                  }
                                }}
                                className="px-2 py-1 border rounded-md w-20 bg-orange-50"
                              />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  {/* Mobile Card View */}
                  <div className="md:hidden space-y-3">
                    {itemIngredientList.map((item, index) => (
                      <div key={index} className="bg-gray-50 border border-gray-200 rounded-lg p-4">
                        <div className="space-y-3">
                          <div>
                            <p className="text-sm font-medium text-gray-900 mb-1">{item?.ingredient}</p>
                            <p className="text-xs text-gray-600">Required Qty: <span className="font-medium">{item?.required_qty}</span></p>
                          </div>

                          <div className="grid grid-cols-2 gap-3">
                            <div>
                              <label className="block text-xs text-gray-600 mb-1">Avg. Wastage (%)</label>
                              <input type="number"
                                id="wastage"
                                name="wastage"
                                value={item?.wastage}
                                onChange={handleInputChange(index)}
                                onWheel={(e) => e.target.blur()}
                                onKeyDown={(e) => {
                                  if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                    e.preventDefault();
                                  }
                                }}
                                className="px-2 py-1 border rounded-md w-full bg-orange-50 text-sm"
                                disabled={lockScreen}
                              />
                            </div>

                            <div>
                              <label className="block text-xs text-gray-600 mb-1">Gross Required Qty</label>
                              <input type="number"
                                id="gross_required_qty"
                                name="gross_required_qty"
                                value={item?.gross_required_qty}
                                onChange={handleInputChange(index)}
                                disabled={lockScreen}
                                onWheel={(e) => e.target.blur()}
                                onKeyDown={(e) => {
                                  if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                    e.preventDefault();
                                  }
                                }}
                                className="px-2 py-1 border rounded-md w-full bg-orange-50 text-sm"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                {/*footer*/}
                {/* Footer */}
                <div className="flex flex-col sm:flex-row items-center justify-between p-3 sm:p-6 border-t border-solid border-blueGray-200 rounded-b space-y-2 sm:space-y-0">
                  {!lockScreen && (
                    <button
                      className="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-4 py-2 rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150"
                      type="button"
                      onClick={() => handleAddItem()}
                    >
                      Save Changes
                    </button>
                  )}

                  <div className="flex flex-col sm:flex-row sm:space-x-2 space-y-2 sm:space-y-0">
                    <button
                      className="text-blue-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none ease-linear transition-all duration-150 border border-blue-500 rounded hover:bg-blue-50"
                      type="button"
                      onClick={handleClose}
                    >
                      Close
                    </button>
                    {!lockScreen && (
                      <button
                        className="bg-rose-500 text-white active:bg-rose-600 font-bold uppercase text-sm px-4 py-2 rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150"
                        type="button"
                        onClick={() => handleSumitForOrder()}
                      >
                        Submit for Order
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
      ) : null}
    </>
  );
};

export default RequirementModel;
